import React, { useState } from "react";
import { Dropdown, Input } from "antd";
import { useTranslation } from "react-i18next";
import { CheckOutlined, SearchOutlined } from "@ant-design/icons";
import LocalLanguage from "../../../assets/svg/Locallanguage.svg";

const LanguageDropdown = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const [searchTerm, setSearchTerm] = useState("");

  const allLanguages = [
    { key: "en", label: "English", flag: "https://flagcdn.com/w20/gb.png" },
    { key: "ar", label: "Arabic", flag: "https://flagcdn.com/w20/sa.png" },
    { key: "hi", label: "Hindi", flag: "https://flagcdn.com/w20/in.png" },
    { key: "ur", label: "Urdu", flag: "https://flagcdn.com/w20/pk.png" }, // ✅ Urdu added
    { key: "pt", label: "Portuguese", flag: "https://flagcdn.com/w20/pt.png" },
    { key: "fr", label: "French", flag: "https://flagcdn.com/w20/fr.png" },
    { key: "it", label: "Italian", flag: "https://flagcdn.com/w20/it.png" },
    { key: "de", label: "German", flag: "https://flagcdn.com/w20/de.png" },
    { key: "es", label: "Spanish", flag: "https://flagcdn.com/w20/es.png" },
  ];

  const filteredLanguages = allLanguages.filter((lang) =>
    lang.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const items = [
    {
      key: "search",
      disabled: true,
      label: (
        <div className="language-search-container">
          <Input
            placeholder="Search Language"
            size="small"
            prefix={<SearchOutlined />}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="custom-input"
          />
        </div>
      ),
    },
    ...filteredLanguages.map((lang) => ({
      key: lang.key,
      label: (
        <div className="language-item">
          <div className="language-info">
            <img src={lang.flag} alt={lang.label} />
            {lang.label}
          </div>
          {currentLang === lang.key && (
            <CheckOutlined className="language-check" />
          )}
        </div>
      ),
    })),
  ];

  const handleLanguageChange = ({ key }) => {
    if (key !== "search") {
      i18n.changeLanguage(key);
    }
  };

  return (
    <Dropdown
      menu={{ items, onClick: handleLanguageChange }}
      trigger={["click"]}
      placement="bottomRight"
      overlayClassName="language-dropdown"
    >
      <img
        src={LocalLanguage}
        alt="Language"
        className="language-trigger-icon"
      />
    </Dropdown>
  );
};

export default LanguageDropdown;
